module.exports = __webpack_public_path__ + "static/img/packs-bg.923796e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/packs-bg.png
// module id = zJeB
// module chunks = 0